import { Link } from 'react-router-dom';

const HeroSection = () => {
    return (
        <section className="bg-background">
            <div className="container mx-auto max-w-4xl px-6 pt-16 pb-12 md:pt-24 md:pb-16 text-center">
                {/* Headline */}
                <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold tracking-tight text-foreground mb-5 leading-tight">
                    Decision intelligence for learning
                </h1>

                {/* Subheadline */}
                <p className="text-lg md:text-xl text-muted-foreground max-w-2xl mx-auto leading-relaxed">
                    Pinpoint Edu diagnoses learning gaps, prioritizes high-impact skills, and guides practice to maximize score improvement per hour.
                </p>

                {/* Closed-beta CTA (R9): low-weight text link under the hero, does
                    NOT displace the existing nav "Log in" / "Demo" CTAs. mailto per D2/R23. */}
                <p className="mt-6 text-sm text-muted-foreground">
                    In closed beta —{' '}
                    <a
                        href="mailto:yangmu@pinpointedu.com"
                        className="font-medium underline underline-offset-4 text-primary/80 hover:text-primary"
                    >
                        request access
                    </a>
                </p>

                {/* Subtle inline deep-link */}
                <p className="mt-10 text-center text-sm md:text-base text-muted-foreground leading-relaxed">
                    Want to understand how prioritization works? Learn more in the{' '}
                    <Link
                        to="/decision-system"
                        className="font-medium underline underline-offset-4 text-primary/70 decoration-primary/30 hover:text-primary/90 hover:decoration-primary/50"
                    >
                        Decision & Prioritization System overview
                    </Link>.
                </p>
            </div>
        </section>
    );
};

export default HeroSection;
